<div class="ring">Loading
  <span></span>
</div>